import { TakeoverAd as TakeoverAdModel } from 'models/TakeoverAd';
import { Rail } from 'components/Shared/Rail';
import Image from 'components/Shared/Image';
import { NotifyLink } from 'components/Shared/NotifyLink';
import connect from 'components/Shared/connect';
import { getCreative, getSlot } from 'components/Ad';
import styles from './styles.scss';
import { GtmPromotion } from 'store/googleTagManager/types';
import { GtmSelectPromotion, GtmViewPromotion } from 'store/googleTagManager/actions';
import { useIntersectionObserver } from 'hooks';
import { TrackedElement } from 'hooks/useIntersectionObserver';

interface OwnProps {
  ad: TakeoverAdModel;
}

interface MergedProps extends OwnProps {
  onAdView: (gtmPromotion: GtmPromotion) => void;
  onAdClick: (gtmPromotion: GtmPromotion) => void;
}

const PICTURE_WIDTH = 250;
const PICTURE_HEIGHT = 500;

// TODO: move this to ad.tsx?
export const _takeoverAd = ({
  ad: { leftImage, rightImage, ...ad },
  onAdClick,
  onAdView
}: MergedProps) => {
  const { setElementRef } = useIntersectionObserver({
    onVisible: handleElementVisible
  });

  function handleElementVisible(element: TrackedElement<GtmPromotion>) {
    onAdView(element.payload);
  }

  const gtmPromotion = {
    promotion_id: ad.googleAnalyticsKey,
    promotion_name: ad.googleAnalyticsName,
    creative_name: getCreative(ad.adTemplate),
    creative_slot: getSlot(1)
  };

  return (
    <div ref={node => setElementRef({ ref: node, payload: gtmPromotion })}>
      <Rail position="left" key="left">
        <NotifyLink ticket={ad.ticket} url={ad.url} onClick={() => onAdClick(gtmPromotion)}>
          <Image
            className={styles.adImage}
            {...leftImage}
            width={PICTURE_WIDTH}
            height={PICTURE_HEIGHT}
          />
        </NotifyLink>
      </Rail>
      <Rail position="right" key="right">
        <NotifyLink ticket={ad.ticket} url={ad.url} onClick={() => onAdClick(gtmPromotion)}>
          <Image
            className={styles.adImage}
            {...rightImage}
            width={PICTURE_WIDTH}
            height={PICTURE_HEIGHT}
          />
        </NotifyLink>
      </Rail>
    </div>
  );
};

export const TakeoverAd = connect<MergedProps, OwnProps>(undefined, dispatch => ({
  onAdView: (promotion: GtmPromotion) => dispatch(GtmViewPromotion(promotion)),
  onAdClick: (promotion: GtmPromotion) => dispatch(GtmSelectPromotion(promotion))
}))(_takeoverAd);
